module.exports = __webpack_public_path__ + "static/img/redpointer.b31bc7c7.svg";